// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import loadExtraProductsByIds from "@store/Framework/Store/Store/Components/ProductDetailsExtraProduct/Handlers/LoadExtraProductsByIds";
import ProductDetailsExtraProductTile from "@store/Library/Components/ProductDetails/ProductDetailsExtraProductTile";
import GetProductContext from "@toolkit/Framework/Components/ProductContext/GetProductContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    tileTitle = "tileTitle",
    productRelationship = "productRelationship",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.tileTitle]: string;
        [fields.productRelationship]: string;
    };
}

type MergedProps = OwnProps & HasProduct;

const mapStateToProps = (state: ApplicationState, ownProps: MergedProps) => {
    const productRelation = ownProps.fields.productRelationship;
    const extraProductId =
        productRelation === "replacementProductId"
            ? ownProps.product.detail?.replacementProductId
            : ownProps.product.properties?.[productRelation];
    const productState = getProductState(state, extraProductId ?? undefined);

    return {
        productState,
        extraProductId,
    };
};

const mapDispatchToProps = {
    loadExtraProductsByIds,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ProductDetailsExtraProduct = ({ productState, fields, loadExtraProductsByIds, extraProductId }: Props) => {
    const { tileTitle } = fields;

    if (!extraProductId) {
        return null;
    }

    const productDetailsExtraProductId = `product-details-extra-product-${extraProductId}`;

    React.useEffect(() => {
        if (!productState.value) {
            loadExtraProductsByIds({
                id: productDetailsExtraProductId,
                productIds: [extraProductId],
            });
        }
    }, [extraProductId]);

    if (!productState.value || productState.isLoading) {
        return null;
    }

    return (
        <GetProductContext product={productState.value}>
            <ProductDetailsExtraProductTile title={tileTitle} />
        </GetProductContext>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsExtraProduct)),

    definition: {
        displayName: "Product Details Extra Product",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.tileTitle,
                displayName: "Tile Title",
                editorTemplate: "TextField",
                defaultValue: "Extra Product Tile Title",
                isRequired: true,
                fieldType: "General",
            },
            {
                name: fields.productRelationship,
                displayName: "Product Relationship to show",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductDetailsExtraProductRelationships",
                defaultValue: "",
                isRequired: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
